module.exports = __webpack_public_path__ + "img/DISCONNECTED.a8a6c0c7.svg";